/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateInviteRoleRequestBody = {
  /**
   * WorkOS invitation ID.
   */
  invitationId: string;
  /**
   * Role ID to assign to the invitee.
   */
  roleId: string;
};

/** @internal */
export type UpdateInviteRoleRequestBody$Outbound = {
  invitation_id: string;
  role_id: string;
};

/** @internal */
export const UpdateInviteRoleRequestBody$outboundSchema: z.ZodMiniType<
  UpdateInviteRoleRequestBody$Outbound,
  UpdateInviteRoleRequestBody
> = z.pipe(
  z.object({
    invitationId: z.string(),
    roleId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      invitationId: "invitation_id",
      roleId: "role_id",
    });
  }),
);

export function updateInviteRoleRequestBodyToJSON(
  updateInviteRoleRequestBody: UpdateInviteRoleRequestBody,
): string {
  return JSON.stringify(
    UpdateInviteRoleRequestBody$outboundSchema.parse(
      updateInviteRoleRequestBody,
    ),
  );
}
